export const clamp = (x, a, b) => Math.max(a, Math.min(b, x));
export const dist = (a, b) => Math.hypot(a.x - b.x, a.z - b.z);
export const normalize = (x, z) => { const d = Math.hypot(x, z); return d > .00001 ? { x: x / d, z: z / d } : { x: 0, z: -1 }; };
export const lerp = (a, b, t) => a + (b - a) * t;
export const angleLerp = (a, b, t) => a + Math.atan2(Math.sin(b-a), Math.cos(b-a)) * t;
export function random(seed = 1) {
  let s = seed >>> 0;
  return () => { s += 0x6D2B79F5; let t = s; t = Math.imul(t ^ t >>> 15, t | 1); t ^= t + Math.imul(t ^ t >>> 7, t | 61); return ((t ^ t >>> 14) >>> 0) / 4294967296; };
}
/** Segment-circle intersection: returns the earliest normalized time, or Infinity. */
export function segmentCircle(ax, az, bx, bz, cx, cz, radius) {
  const dx=bx-ax, dz=bz-az, ox=ax-cx, oz=az-cz;
  const a=dx*dx+dz*dz, c=ox*ox+oz*oz-radius*radius;
  if(c <= 0) return 0;
  if(a < 1e-10) return Infinity;
  const b=2*(ox*dx+oz*dz), disc=b*b-4*a*c;
  if(disc<0) return Infinity;
  const t=(-b-Math.sqrt(disc))/(2*a);
  return t>=0 && t<=1 ? t : Infinity;
}
export function segmentBox(ax, az, bx, bz, box, padding = 0) {
  let lo=0, hi=1;
  for(const [a,d,mn,mx] of [[ax,bx-ax,box.x-box.w/2-padding,box.x+box.w/2+padding],[az,bz-az,box.z-box.h/2-padding,box.z+box.h/2+padding]]) {
    if(Math.abs(d)<1e-9) { if(a<mn || a>mx) return Infinity; continue; }
    let t0=(mn-a)/d, t1=(mx-a)/d;
    if(t0>t1) [t0,t1]=[t1,t0];
    lo=Math.max(lo,t0); hi=Math.min(hi,t1);
    if(lo>hi) return Infinity;
  }
  return lo;
}
